import { hooks } from '@wove/react';
import { useContext, useRef } from 'react';
import { useEffectCustom } from '../hooks';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import { StickyTabsContext } from './context';

export type StickyTabsItemProps = { stickyKey: string } & CommonPropsWithChildren;

export const StickyTabsItem = (props: StickyTabsItemProps) => {
  const context = useContext(StickyTabsContext);
  const ref = useRef<HTMLDivElement>(null);
  useEffectCustom(() => {
    const offsetTop = ref.current?.offsetTop || 0;
    const offsetHeight = ref.current?.offsetHeight || 0;
    context?.onChangeStickyItem({
      stickyKey: props.stickyKey,
      minOffsetTop: offsetTop,
      maxOffsetTop: offsetTop + offsetHeight,
    });
  }, [context?.stickyItemRefresh]);

  hooks.useUnmountEffect(() => {
    context?.onDestroyStickyItem({ stickyKey: props.stickyKey });
  });

  return withNativeProps(
    props,
    <div className="v-sticky-tabs-item" ref={ref}>
      {props.children}
    </div>,
  );
};

StickyTabsItem['domTypeName'] = 'StickyTabsItem';
